import { useSelector } from 'react-redux';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

import { sideBarConfig } from 'components/layout/SideBar/SideBarConfig';

import useAccessControl from 'hooks/useAccessControl';

import ErrorPage from 'pages/Errors/ErrorPage';
import PageNotFound from 'pages/Errors/PageNotFound';
import PermissionDenied from 'pages/Errors/PermissionDenied';

const MainPage = () => {
	const { state } = useLocation();

	if (state?.error) {
		window.history.replaceState({}, document.title);
		return <ErrorPage />;
	}

	if (state?.permissionDenied) {
		window.history.replaceState({}, document.title);
		return <PermissionDenied />;
	}

	if (state?.pageNotFound) {
		window.history.replaceState({}, document.title);
		return <PageNotFound />;
	}

	return <NavigateDefaultPage />;
};

const NavigateDefaultPage = () => {
	const [searchParams] = useSearchParams();
	const isAuthorized = useAccessControl();
	const user = useSelector((state) => state.user);

	const findFirstLink = (menuList) =>
		menuList.reduce((found, item) => {
			if (found) return found;
			if (item.links && item.links.length) {
				return findFirstLink(item.links);
			}
			return isAuthorized(item.path) ? item.path : null;
		}, null);

	const firstItem = findFirstLink(sideBarConfig);

	const defaultPage = JSON.parse(window.localStorage.getItem(`${user.ID}_defaultPage`));

	return (
		<Navigate
			replace
			to={
				(defaultPage?.path ?? firstItem ?? '/home') +
				(searchParams.size > 0 ? `?${searchParams.toString()}` : '')
			}
		/>
	);
};

export default MainPage;
